<script lang='ts' context='module'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import {
        type AUCTION_API,
        Heading,
        QUERY_STATE,
        SelectAuctionOrderBy,
    } from '@smatch/cassiopeia-web-components';

    // PLUGINS
    import { getContext } from 'svelte';

    /* TYPES ------------------------------------------------------------------------------------ */

    type QueryParameters = Required<Pick<AUCTION_API.QueryParameters, 'direction' | 'orderBy'>>;

    /* INTERFACES ------------------------------------------------------------------------------- */

    export const DEFAULTS: QueryParameters = {
        direction: 'desc',
        orderBy: 'durationStart',
    };

</script>

<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // STYLING
    import 'tailwindcss/tailwind.css';

    /* INITIALIZE ------------------------------------------------------------------------------ */

    const SCOPE: string = getContext('scope');

    /* INTERNALS -------------------------------------------------------------------------------- */

    const getDefault = (): QueryParameters => {
        const PARAMETERS = QUERY_STATE.getScope(SCOPE) as QueryParameters | null;

        if (PARAMETERS === null) {
            return { ...DEFAULTS };
        }

        return Object.fromEntries(Object
            .entries(DEFAULTS)
            .map(([ key, value ]) => [ key, PARAMETERS[key] ?? value ])) as QueryParameters;
    };

    const PARAMETERS: QueryParameters = getDefault();

    $: QUERY_STATE.updateScope({ ...PARAMETERS }, SCOPE);

</script>

<div class = 's8-header'>
    <Heading size = 'lg'>Deals</Heading>
    <SelectAuctionOrderBy
        bind:orderBy = { PARAMETERS.orderBy }
        bind:direction = { PARAMETERS.direction }
    />
</div>

<style lang='postcss'>
    div.s8-header {
        display: flex;
        align-items: flex-start;

        :global(> *:first-child) {
            flex-grow: 1;
        }
    }
</style>